import { Component, Input, OnInit } from '@angular/core';
import { Formats } from '../core/constants';

@Component({
    selector: 'tv-detail-audit',
    templateUrl: './detail.audit.component.html',
    styleUrls: []
})
export class DetailAuditComponent implements OnInit {

    @Input()
    public model: any;

    constructor(public formats: Formats) {
    }

    ngOnInit() {
      if (!this.model.status) {
        this.model.status = null;
      }

      if (!this.model.version) {
        this.model.version = null;
      }

      if (!this.model.changedByName) {
        this.model.changedByName = '';
      }

      if (!this.model.authorisedByName) {
        this.model.authorisedByName = '';
      }
      console.log('OnInit', this.model);
    }

}
